import React from "react";

export const DepotsContext = React.createContext(
    {
        depots: [],
        ppays: [],
        refreshDepots: () => null
    }
)